/**
 * bh-cart-gift.js — "Добави" claim button on the free birthday candle row of each eligible cake
 * (snippets/bh-cart-gift-row.liquid), on the cart page and in the cart drawer.
 *
 * The candle ships with every eligible cake whether or not this is tapped (Vlad, 2026-10-19). The
 * button is the small reward of claiming it: ✓, a pop, a confetti burst, a success haptic (bh-haptic.js) and a
 * Clarity event to count claims. Nothing is added to the cart or the order.
 * Claimed state is remembered per cake (_Cake_ID) in localStorage, so a reload or a re-rendered
 * drawer keeps the ✓, and a new cake starts unclaimed.
 * Loaded from both the drawer and the cart page; the guard keeps one copy of the listeners.
 */
(function () {
  if (window.__bhCartGift) return;
  window.__bhCartGift = true;

  // Small confetti burst from the button (canvas-confetti, loaded by the snippet's script tag).
  // The library itself skips it for prefers-reduced-motion.
  function burst(btn) {
    if (!window.confetti) return;
    var r = btn.getBoundingClientRect();
    window.confetti({
      particleCount: 40,
      spread: 60,
      startVelocity: 25,
      ticks: 120,
      scalar: 0.8,
      origin: { x: (r.left + r.width / 2) / innerWidth, y: (r.top + r.height / 2) / innerHeight },
      colors: ['#ab4c9d', '#17563a', '#f2c94c', '#ffffff'], // brand magenta (--color-accent), gift green, gold, white
      zIndex: 9999, // above the cart drawer (the library's default 100 sits under it)
      disableForReducedMotion: true
    });
  }

  function key(row) { return 'bhGiftClaimed:' + (row.getAttribute('data-cake') || ''); }
  function isClaimed(row) { try { return !!localStorage.getItem(key(row)); } catch (e) { return false; } }

  function markClaimed(btn) {
    btn.setAttribute('aria-pressed', 'true');
    btn.textContent = btn.getAttribute('data-added');
  }

  // Rows appear on load and whenever the drawer re-renders; restore their ✓.
  function sync() {
    document.querySelectorAll('[data-bh-gift]').forEach(function (row) {
      var btn = row.querySelector('.bh-cart-gift__btn');
      if (btn && btn.getAttribute('aria-pressed') !== 'true' && isClaimed(row)) markClaimed(btn);
    });
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bh-gift] .bh-cart-gift__btn');
    if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
    var row = btn.closest('[data-bh-gift]');
    markClaimed(btn);
    btn.classList.add('is-pop');
    if (window.bhHaptic) window.bhHaptic('success');
    burst(btn);
    if (window.bhClarityEvent) window.bhClarityEvent('bh_gift_candle_claimed');
    try { localStorage.setItem(key(row), '1'); } catch (e2) {}
  });
})();
